<template>
	<button class="btn btn-border btn--border btn-auth" @click="ShowAuthLoginPopup = !ShowAuthLoginPopup">Войти</button>

	<transition name="modal">
		<AuthLoginPopup v-if="ShowAuthLoginPopup" @close="ShowAuthLoginPopup = false" />
	</transition>
</template>

<script>
import AuthLoginPopup from "@/components/forms/AuthLoginPopup.vue";

export default {
	name: 'AuthBtn',
	components: {AuthLoginPopup},
	data() {
		return {
			ShowAuthLoginPopup: false
		}
	},
}
</script>
